<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <b-form-select
      :disabled="is_disabled"
      :label="field_label"
      :value="field_value"
      @input="on_input"
      v-bind="field.params"
      :options="effectiveOptions"
      v-if="layout === 'select'"
    >
      <b-form-select-option
        v-if="field.params.placeholder"
        :value="null"
        disabled
        >{{ field.params.placeholder }}
      </b-form-select-option>
    </b-form-select>

    <b-form-radio-group
      :checked="field_value"
      :disabled="is_disabled"
      :label="field_label"
      :stacked="field.params.stacked"
      :options="effectiveOptions"
      @input="on_input"
      v-bind="field.params"
      v-if="layout === 'radios'"
    ></b-form-radio-group>

    <b-form-radio-group
      :checked="field_value"
      :label="field_label"
      :stacked="field.params.stacked"
      :options="effectiveOptions"
      @input="on_input"
      :disabled="is_disabled"
      button-variant="outline-secondary"
      buttons
      v-bind="field.params"
      v-if="layout === 'buttons'"
    ></b-form-radio-group>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import AjaxOptionsMixin from "../AjaxOptionsMixin.js";
import FFormGroup from "../FFormGroup.vue";

export default {
  name: "SelectWidget",
  components: { FFormGroup },
  mixins: [FormWidgetMixin, AjaxOptionsMixin],
  computed: {
    layout() {
      return this.field.params.layout || "select";
    },
  },
};
</script>
